import { defineMessages } from 'react-intl';

const messages = defineMessages({
  phoneNumberWarning: {
    id: 'phoneNumber.warning',
    defaultMessage: 'Please enter valid phone number',
    description: 'Invalid phone number message',
  },
  phoneNumberError: {
    id: 'phoneNumber.error',
    defaultMessage:
      "The phone number you entered doesn't appear to be valid for this country. Please double-check it, or continue with the current number.",
    description: 'Invalid phone number message',
  },
  phoneNumberApiError: {
    id: 'phoneNumber.apiError',
    defaultMessage:
      'We are currently unable to validate your phone number. Please try again later or continue with the current number.',
    description: 'Phone number API error message',
  },
  phoneNumberTooShort: {
    id: 'phoneNumber.tooShort',
    defaultMessage:
      'The phone number you entered is too short for this country. Please double-check the number or continue with the current number.',
    description: 'Phone number too short message',
  },
  phoneNumberTooLong: {
    id: 'phoneNumber.tooLong',
    defaultMessage:
      'The phone number you entered is too long for this country. Please double-check the number or continue with the current number.',
    description: 'Phone number too long message',
  },
  phoneNumberUknownError: {
    id: 'phoneNumber.unknownError',
    defaultMessage:
      "We're having trouble validating your phone number at the moment. Please try again later or continue with the current number.",
    description: 'Unknown phone number error message',
  },
  phoneNumberValidated: {
    id: 'phoneNumber.validated',
    defaultMessage: 'Phone number successfully validated.',
    description: 'Phone number validated message',
  },
});

export default messages;
